module.exports = __webpack_public_path__ + "img/SK00151653.766f6bc5.png";